import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

/**
 * Renders a dialog component for upgrading to premium.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.open - Determines if the dialog is open or not.
 * @param {Function} props.onClose - Callback function to handle dialog close event.
 * @param {boolean} props.isAnon - Determines if the user is anonymous or not.
 * @param {Function} props.handleButtonUpgrade - Callback function to handle upgrade button click event.
 * @returns {JSX.Element} The rendered RegWall component.
 */
const RegWall = ({ open, onClose, isAnon, handleButtonUpgrade }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Upgrade to Premium</DialogTitle>
            <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
                <img src="/modules/contrib/gtc/images/pub.png" alt="Pub" style={{ width: '250px', height: '250px' }} />
                {isAnon ?
                    <p>Sign in or Create an account to access premium features</p>
                    :
                    <p>Access enhanced features and benefits by subscribing to our Premium plan. Note: During our beta testing phase, all users are granted complimentary access to these premium features, which will last for the duration of this session</p>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => handleButtonUpgrade()} color="primary">
                    Try Premium!
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RegWall;